import { appLocale } from '@/ui/i18n';

import FairlyScoreLogo from '../assets/fairly_score_logo.svg';

type PdfProjectPagerProps = {
  current: number;
  total: number;
};

export function PdfProjectPager({ current, total }: PdfProjectPagerProps) {
  const date = new Date().toLocaleDateString(appLocale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  return (
    <div className="pdf-festival-pager">
      <img src={FairlyScoreLogo} width="100" height="27" alt="Fairly logo" />
      <div
        style={{
          color: '#322222',
          fontSize: 11,
          fontFamily: 'Urbanist Variable',
          fontWeight: '600',
        }}
      >
        Rapport généré le {date} via l'application fairly-score
      </div>
      <div
        style={{
          color: '#322222',
          fontSize: 11,
          fontFamily: 'Urbanist Variable',
          fontWeight: '400',
          marginLeft: 25,
        }}
      >
        Tous droits réservés © fairly.run
      </div>
      <div
        style={{
          padding: 6,
          background: '#322222',
          borderRadius: 4,
          justifyContent: 'center',
          alignItems: 'center',
          gap: 10,
          display: 'inline-flex',
        }}
      >
        <div
          style={{
            color: 'white',
            fontSize: 11,
            fontFamily: 'Urbanist Variable',
            fontWeight: '600',
            lineHeight: 1,
            paddingTop: 2.5,
            paddingBottom: 2,
            paddingLeft: 3,
            paddingRight: 3,
          }}
        >
          {current}/{total}
        </div>
      </div>
    </div>
  );
}
